module.exports = __webpack_public_path__ + "img/lQLPJwBVVz3Y4UXNBIDNBQCwTWIasjYIcmEHiByE3B2PAA_1280_1152.e41e29a7.png";